import { client } from '../utils'
import { reader as endpoints } from '../api_urls'

/**
  Action function that retrieves the navigation toolbar data
*/
export const getNavigationToolbarData = (chapterID, pageID) => {
  return async dispatch => {
    let url = endpoints.retrieveAnalytics({ chapterID, pageID })
    try {
      var response = await client.get(url)
    } catch (err) {
      console.error(`Error fetching ${url}`, err)
      return
    }
    dispatch(updateNavigationToolbarData(response.data))
  }
}

/**
  Action function that updates the navigation toolbar with the passed in data
*/
export const updateNavigationToolbarData = navigationToolbarData => {
  return {
    type: 'UPDATE_NAVIGATION_TOOLBAR',
    navigationToolbarData,
  }
}

/**
  Action function that opens / closes the reader toolbar modal
*/
export const toggleReaderToolbarModal = showReaderToolbarModal => {
  handleModalChange(showReaderToolbarModal)

  return {
    type: 'TOGGLE_READER_TOOLBAR_MODAL',
    payload: showReaderToolbarModal,
  }
}

/**
  Action function that opens / closes the reader navigation modal
*/
export const toggleReaderNavigationModal = showReaderNavigationModal => {
  handleModalChange(showReaderNavigationModal)

  return {
    type: 'TOGGLE_READER_NAVIGATION_MODAL',
    payload: showReaderNavigationModal,
  }
}

/**
  Helper function that handles reader page changes on modal open / close
*/
const handleModalChange = isModal => {
  if (isModal) {
    $('#navigation_arrow_right').hide()
    $('#navigation_arrow_left').hide()
    $('html').addClass('ResponsiveModal_HTML-override')
  } else {
    $('#navigation_arrow_right').show()
    $('#navigation_arrow_left').show()
  }
}
